import { call, put, select, takeEvery } from 'redux-saga/effects';
import { DeleteNewDealerRequestEvent, newDealerActionCreators, NewDealerActionKeys } from '../';
import { IState } from '../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../newDealerApi';
import { INewDealerRequestEvent } from '../newDealerInterfaces';
import { getNewDealerRequestEvent } from '../newDealerSelectors';

function* deleteNewDealerRequestEvent(action: DeleteNewDealerRequestEvent) {
  yield put(newDealerActionCreators.toggleEventSave(action.payload));

  const event: INewDealerRequestEvent = yield select((state: IState) =>
    getNewDealerRequestEvent(state, action.payload)
  );

  if (event) {
    const response: IApiExecuteRespone<IEntityWithMessages<number>> = yield call(
      api.deleteNewDealerRequestEvent,
      event.newDealerRequestEventId
    );

    if (!response.requestFailed && response.value) {
      yield processMessages(response.value);

      if (response.value.value) {
        yield put(newDealerActionCreators.removeEvent(response.value.value));
      }
    } else {
      yield showFailedRequestDialog(response);
    }
  }

  yield put(newDealerActionCreators.toggleEventSave(action.payload));
}

export function* watchDeleteNewDealerRequestEvent() {
  yield takeEvery(NewDealerActionKeys.DELETE_NEW_DEALER_REQUEST_EVENT, deleteNewDealerRequestEvent);
}
